import React, { useMemo } from 'react'

import { Alert, AppSvg, Button, FormattedHTMLMessage, newIcons, Spinner } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import { SettingsTabs } from '~pages/CardsPage/Cards/Settings/SettingsModal/types'
import { useGetThreeDSConfigData, useGetThreeDSQuestionsData } from '~api'

interface Props {
    onClose?: () => void
    setTab: (tab: SettingsTabs) => void
    card?: GetCard
    onReset?: () => void
    isResetLoading?: boolean
}

// eslint-disable-next-line max-lines-per-function,complexity
function Question({ onClose, setTab, card, onReset, isResetLoading }: Props) {
    const { data: config, isLoading: isConfigLoading } = useGetThreeDSConfigData({ id: card?.id || '' })
    const { data: questions, isLoading: isQuestionsLoading } = useGetThreeDSQuestionsData({ id: card?.id || '' })

    const kba = useMemo(() => {
        return config?.methods?.find(method => method?.name === 'KBA')
    }, [config])

    const isSuccess = !!kba?.enrolled
    const isSomeAnswered = questions?.questions?.some(q => !!q.answered)

    if (isQuestionsLoading || isConfigLoading) {
        return (
            <div className={s.loadingWrap}>
                <Spinner size={30} intent="accent" />
            </div>
        )
    }

    return (
        <div className={s.wrap}>
            <FormattedHTMLMessage {...lang.title} className={s.title} />
            <div className={s.content}>
                <FormattedHTMLMessage {...lang.description} className={s.description} />
                <Alert
                    icon={<AppSvg svgName={newIcons.ic16Alert} size={16} path="new-icons" />}
                    dataPointer="alert"
                    text={
                        <FormattedHTMLMessage
                            {...(isSuccess ? lang.successAlert : lang.warningAlert)}
                            className={s.textAlert}
                        />
                    }
                    type={isSuccess ? 'success' : 'warning'}
                    className={s.alert}
                />
            </div>
            <div className={s.button}>
                {isSomeAnswered && (
                    <Button
                        dataPointer="setup"
                        size="l"
                        onClick={onReset}
                        prefix={<AppSvg svgName={newIcons.ic24Refresh} size={24} path="new-icons" />}
                        fullWidth
                        isLoading={isResetLoading}
                    >
                        <FormattedHTMLMessage {...lang.reset} />
                    </Button>
                )}
                {isSuccess && (
                    <Button dataPointer="setup" size="l" mode="primary" onClick={onClose} fullWidth>
                        <FormattedHTMLMessage {...lang.close} />
                    </Button>
                )}
                {!isSuccess && isSomeAnswered && (
                    <Button
                        dataPointer="setup"
                        size="l"
                        mode="primary"
                        onClick={() => setTab(SettingsTabs.threeDSQuestionFlow)}
                        fullWidth
                    >
                        <FormattedHTMLMessage {...lang.continue} />
                    </Button>
                )}
                {!isSuccess && !isSomeAnswered && (
                    <Button
                        dataPointer="setup"
                        size="l"
                        mode="primary"
                        onClick={() => setTab(SettingsTabs.threeDSQuestionFlow)}
                        fullWidth
                    >
                        <FormattedHTMLMessage {...lang.setup} />
                    </Button>
                )}
            </div>
        </div>
    )
}

export default Question
